import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import AppLayout from '@/layouts/AppLayout.vue'
import DevPanel from '@/components/DevPanel.vue'
import '@sennder/design-system-core'
import '@sennder/design-system-core/dist/styles/themes/default.css'
import '@sennder/shell-utilities/dist/style.css'

export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(AppLayout),
    _createVNode(DevPanel)
  ], 64 /* STABLE_FRAGMENT */))
}
}

})